import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

export const step1 = {
  items: [
    {
      title: capitalize(i18n.t("branch.offices")),
      arrow: true,
      to: "/admin/businessnodes",
      permission: 'read_nodes',
    },
    // {
    //   title: i18n.t("Dispositivos"),
    //   arrow: true,
    //   to: "/admin/devices",
    //   permission: 'read_devices',
    // },
    {
      title: capitalize(i18n.t("clients")),
      arrow: true,
      to: "/admin/clients",
      permission: 'read_persons',
    },
    {
      title: i18n.t("providers"),
      arrow: true,
      to: "/admin/providers",
      permission: 'read_persons',
    },
    {
      title: i18n.t("external.applications"),
      arrow: true,
      to: "/admin/applications",
      permission: 'read_apps',
    },
    {
      title: i18n.t("companies"),
      arrow: true,
      to: "/admin/businesses",
      permission: 'all',
    },
    {
      title: capitalize(i18n.t("users")),
      arrow: true,
      to: "/admin/users",
      permission: 'read_users',
    },
    {
      title: i18n.t("roles"),
      arrow: true,
      to: "/admin/roles",
      permission: 'read_roles',
    },
  ],
  headerTitle: capitalize(i18n.t("configurations")),
  navHidden: false,
  goBackTo: 0,
};
